import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { KeycloakContext } from "../../context/KeycloakContext"; // or wherever it is
import { getMeasurementPdf } from "../../helpers/ApiRequests";
import LanguageSelector from "../../Shared/LanguageSelector";
import {Button} from "primereact/button";

const ShowMeasurementPage: React.FC = () => {
  // 1) Grab measurementUUID from URL params
  const { measurementUUID } = useParams();
  
  // 2) Access KeycloakContext to get theme (even if user is not logged in)
  const { theme, appInsights } = useContext(KeycloakContext);
  
  // 3) i18n to get current language TODO: check if language can be added via query param e.g. encoded in the QR code
  const { t, i18n } = useTranslation();
  
  const navigate = useNavigate();
  
  const [enteredUUID, setEnteredUUID] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");

  /**
   * If there's a measurementUUID in the URL, fetch & open the PDF automatically.
   */
  useEffect(() => {
    if (measurementUUID) {
      handleFetchPdf(measurementUUID);
    }
  }, [measurementUUID]);

  /**
   * Core logic to fetch & open (or download) the PDF.
   */
  const handleFetchPdf = async (uuid: string) => {
    try {
      // Use the theme from context and the language from i18n
      const pdfBlob = await getMeasurementPdf(uuid, theme, i18n.language);

      // Create a blob URL and open it in new tab
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");

      // Optionally, you might want to navigate back to /ShowMeasurement
      // to remove the UUID from the URL after opening. Up to you.
      navigate("/ShowMeasurement");
    } catch (error: any) {
      console.error("handleFetchPdf error:", error);
      setErrorMessage(error.message || t("Error fetching PDF"));
    }
  };

  /**
   * Handler for the "Download PDF" button when user typed a UUID manually
   */
  const handleDownloadClick = () => {
    if (!enteredUUID) {
      setErrorMessage(t("Please enter a valid ID."));
      return;
    }

    if (appInsights) {
        console.log("Generate PDF insight");

        appInsights.trackEvent({ name: "Generate PDF" });
      }

    // Navigate to /ShowMeasurement/:enteredUUID so useEffect can pick it up
    navigate(`/ShowMeasurement/${enteredUUID}`);
  };

  return (
    <div style={{ margin: "2rem" }}>
      <h2>{t("PDF.DownloadPage.Title")}</h2>
      <LanguageSelector appInsights={appInsights}/>

      {/* If we have a measurementUUID param, we attempt to load the PDF. */}
      {measurementUUID ? (
        <>
          {errorMessage && (
            <p style={{ color: "red" }}>{errorMessage}</p>
          )}
          <p>
            {t("Attempting to load PDF for measurement")} <b>{measurementUUID}</b>.
            <br />
          </p>
        </>
      ) : (
        <>
          <p>
            {t("Enter a measurement ID to download the PDF-Report")}:
          </p>
          <input
            type="text"
            placeholder={t("Measurement ID")}
            value={enteredUUID}
            onChange={(e) => setEnteredUUID(e.target.value)}
            style={{ width: "300px", marginRight: "1rem" }}
          />
            <Button onClick={handleDownloadClick} className="text-center btn-1 w-auto sm:w-1/4"  label={t('DownloadReport')} />
          

          {errorMessage && (
            <p style={{ color: "red" }}>{errorMessage}</p>
          )}
        </>
      )}
    </div>
  );
};

export default ShowMeasurementPage;
